const useIsTouchscreen = () => {
  return typeof window !== "undefined" && navigator.maxTouchPoints > 0;
};

export { useIsTouchscreen };
